// import { useState, useMemo, useEffect, useRef } from "react";

import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  List,
  ListItem,
  Text,
  // useDisclosure,
} from "@chakra-ui/react";

// import { useHistory, useParams } from "react-router-dom";

// import Arrow from "assets/svg/icons-new/arrow.svg";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
// import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import HistoryItem from "components/AffiliateItems/HistoryItem";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
// import toCoinLocale from "util/toCoinLocale";

export default function AffiliateRules(props) {
  //   const { userData } = props;

  //   const { id } = useParams();

  //   const toast = useToast();
  //   const loaded = useRef(false);
  //   const history = useHistory();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //   const [state, _setState] = useState({ type: "price" });

  //   const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <Heading>Rules</Heading>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Bitmama Partners
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    Rules
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px"]}
              //   mt={["24px", "10px"]}
              pb="80px"
              borderRadius={[0, "8px", "16px"]}
            >
              <Text color="#4E4B66" mb="40px">
                Kindly read through the rules for partners below
              </Text>

              <List color="#14142B" fontSize="md" fontWeight="400">
                <ListItem mb="10px">
                  1. Verify to level 3 to become a partner
                </ListItem>
                <ListItem>
                  2. All earnings can be accessed from your crypto wallets on
                  Bitmama.
                </ListItem>
                <ListItem mb="10px">
                  3. You can only earn when the referral completes a
                  transaction.
                </ListItem>
                <ListItem mb="10px">
                  4. The commission rates can be reviewed at our discretion.
                </ListItem>
                <ListItem mb="10px">
                  5. Here are the transactions you can earn on
                  <List pl="20px" mt="20px">
                    <ListItem mt="10px">
                      i. Buy and sell- 2% per transaction
                    </ListItem>
                    <ListItem mt="10px">ii. Swap- 3% per transaction</ListItem>
                    {/* <ListItem mt="10px">
                        iii. BCPL- 15% of our 3% earnings on the loan interest to
                        be earned when the referral pays back the loan
                      </ListItem>
                      <ListItem mt="10px">iv. Card transactions- $0.06</ListItem> */}
                  </List>
                </ListItem>
              </List>
            </Box>
          </Container>
        </Box>
      </Box>

      {/* <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}
    </Box>
  );
}
